import { Geografi, Parti, ValgResultat, PartiValgResultat, PageType } from '../domain'

export type PageState = {
  current: PageType
}

export type GrunndataState = {
  parti: Parti[]
  geografi: Geografi[]
  error?: Error
}

export type ResultsEmptyState = {
  state: 'empty'
}

export type ResultsLoadingState = {
  state: 'loading'
}

export type ResultsLockedState = {
  state: 'locked'
}

export type ResultsReloadingState = {
  state: 'reloading'
  data: ValgResultat | PartiValgResultat
}

export type ResultsLoadedState = {
  state: 'success'
  data: ValgResultat | PartiValgResultat
}

export type ResultsErrorState = {
  state: 'error'
  error: Error
}

export type ResultsState =
  | ResultsEmptyState
  | ResultsLoadingState
  | ResultsReloadingState
  | ResultsLoadedState
  | ResultsLockedState
  | ResultsErrorState

export function isLoaded(results: ResultsState): results is ResultsLoadedState {
  return results.state === 'success'
}

export function isLoading(results: ResultsState): results is ResultsLoadingState {
  return results.state === 'loading'
}

export function isReloading(results): results is ResultsReloadingState {
  return results.state === 'reloading'
}

export function isLocked(results: ResultsState): results is ResultsLockedState {
  return results.state === 'locked'
}

export function isError(results: ResultsState): results is ResultsErrorState {
  return results.state === 'error'
}

export function hasData(results): results is ResultsLoadedState | ResultsReloadingState {
  return isLoaded(results) || isReloading(results)
}

export type AppState = {
  page: PageState
  grunndata: GrunndataState
  fylkesresultat: ResultsState
  kommuneresultat: ResultsState
}
